import { useMultipleCascaderDatasource } from '../../hooks/cascader';
import { MultipleCascader as MultipleCascaderComponents } from './MultipleCascader';
export var MultipleCascader = Object.assign(MultipleCascaderComponents, {
  useMultipleCascaderDatasource: useMultipleCascaderDatasource
});